import { render } from "./LocationSetupComponent.vue?vue&type=template&id=f2252ba6"
import script from "./LocationSetupComponent.vue?vue&type=script&lang=js"
export * from "./LocationSetupComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/LocationSetup/LocationSetupComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f2252ba6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f2252ba6', __exports__)) {
    api.reload('f2252ba6', __exports__)
  }
  
  module.hot.accept("./LocationSetupComponent.vue?vue&type=template&id=f2252ba6", () => {
    api.rerender('f2252ba6', render)
  })

}


export default __exports__